import { SimpleForm } from "react-admin";
import PeAssociationMetricRangesForm from "./PeAssociationMetricRangesForm";
import useFinlandSiteMetricsDialog from "./hooks/useFinlandSiteMetricsDialog";
import { FinlandSiteServiceInfo, NewSitesMetrics } from "../types";

const FINLAND_METRICS_FORM_ID = "finland-site-metrics-form";

const PeMetricsFormContainer = ({
  siteServiceInfos,
  handleSubmit,
}: {
  siteServiceInfos: FinlandSiteServiceInfo;
  handleSubmit: (newMetrics: NewSitesMetrics) => void;
}) => {
  const { configs, selectedSites } = useFinlandSiteMetricsDialog({ siteServiceInfos });

  return (
    <SimpleForm id={FINLAND_METRICS_FORM_ID} toolbar={false} onSubmit={handleSubmit}>
      <PeAssociationMetricRangesForm selectedSites={selectedSites} configs={configs} />
    </SimpleForm>
  );
};

export default PeMetricsFormContainer;
